// Module
var code = `<ul class="list-unstyled"> <li ng-repeat="enumeration in enumerationController.enumerations track by enumeration.value"> <label class="checkbox-inline"> <input type="checkbox" id="enum-{{enumeration.value}}" ng-model="enumeration.checked" ng-change="enumerationController.onChange()"/> {{ enumeration.name }} </label> </li> </ul> `;
// Exports
module.exports = code;